var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.376 12.378H22.39a.5.5 0 0 0 .316-.887L13.2 3.713a.5.5 0 0 0-.634 0L3.06 11.491a.5.5 0 0 0 .317.887Zm1.574 0h15.866v9.416a.5.5 0 0 1-.5.5h-4.458v-5.45a.5.5 0 0 0-.5-.5h-4.95a.5.5 0 0 0-.5.5v5.45H5.45a.5.5 0 0 1-.5-.5v-9.416Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.818 12.378H3.378a.5.5 0 0 1-.317-.887l9.507-7.778a.5.5 0 0 1 .634 0l9.507 7.778a.5.5 0 0 1-.317.887h-1.574Zm1 1h.574c1.41 0 2.04-1.768.95-2.66l-9.507-7.779a1.5 1.5 0 0 0-1.9 0l-9.507 7.778c-1.09.893-.46 2.661.95 2.661h.574v8.416a1.5 1.5 0 0 0 1.5 1.5h5.458v-5.95h3.95v5.95h5.458a1.5 1.5 0 0 0 1.5-1.5v-8.416ZM4.952 21.794a.5.5 0 0 0 .5.5H9.91v-5.45a.5.5 0 0 1 .5-.5h4.95a.5.5 0 0 1 .5.5v5.45h4.458a.5.5 0 0 0 .5-.5v-9.416H4.952v9.416Z",
    fill: "#232427"
  })));
};
export default SvgHome;